import axios from "@lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export interface ThemeInputs {
  name: string;
  language: string;
  active?: boolean;
}

interface SaveThemeProps {
  themeId?: string;
  onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSaveTheme = ({
  themeId,
  onSuccess,
  onError,
}: SaveThemeProps) => {
  const queryClient = useQueryClient();
  const {
    isPending,
    isError,
    error,
    mutate: onSaveTheme,
  } = useMutation({
    mutationFn: async (data: ThemeInputs) => {
      if (themeId) return axios.patch(`/content-parameters/${themeId}`, data);
      return axios.post("/content-parameters", { ...data, type: "THEME" });
    },
    onSuccess: (data) => {
      if (themeId)
        queryClient.invalidateQueries({
          queryKey: ["contentParameter", themeId],
        });
      if (onSuccess) onSuccess(data);
    },
    onError,
  });

  return { onSaveTheme, isPending, isError, error };
};
